import React, { useEffect, useMemo, useState } from 'react'
import { useGeneral } from '../../../context/general'
import useNewsGraph from '../../newsGraph/hooks/useNewsGraph'
import NewsGraph from '../../newsGraph/components/NewsGraph'
// import NewsGraph from '../../newsGraph/components/NewsGraph_old'
import useDataset from '../../newsGraph/hooks/useDataset'
import FeedAlert from '../../FeedAlert'
import { Container, Typography, Autocomplete, TextField, Skeleton, Tooltip } from '@mui/material'
import styles from '../../../pages/Dashboard.module.scss'
import axios from 'axios'


const Daily_Timeperiod_options = [{label:'Last One Day',value:'daily'},{label:'Last One Week',value:'weekly'},{label:'Last One Month',value:'monthly'},{label:'Last Three Months',value:'quarterly'},{label:'Last Six Months',value:'biannually'},{label:'Last One Year',value:'yearly'}]

const Daily_Rolling_options = [{label:'No Rolling',value:'no_rolling'},{label:'5 days',value:'5days'},{label:'10 Days',value:'10days'},{label:'15 Days',value:'15days'},{label:'20 Days',value:'20days'}]

const Monthly_Rolling_options = [{label:'No Rolling',value:'no_rolling'},{label:'3 Months',value:'3months'},{label:'5 Months',value:'5months'},{label:'10 Months',value:'10months'}]

const Quarterly_Rolling_options = [{label:'No Rolling',value:'no_rolling'},{label:'2 Quarters',value:'2quarter'},{label:'4 Quarters',value:'4quarter'},{label:'8 Quarters',value:'8quarter'}]

export default function Feed() {
    const { Datasets } = useDataset()
    // const { userTriggerdAlerts } = useGeneral()
    // const { graphsData } = useNewsGraph()
    const [DatasetOptions, setDatasetOptions] = useState([])
    const [SelectedDataset, setSelectedDataset] = useState(null)
    const [SelectedDatasetFrequency, setSelectedDatasetFrequency] = useState("Daily")
    const [SelectedClientID, setSelectedClientID] = useState()
    const [SelectedDatasetID, setSelectedDatasetID] = useState()

    const [DatasetColumnOptions, setDatasetColumnOptions] = useState([])
    const [SelectedColumn, setSelectedColumn] = useState('')
    const [SelectedColumnValue, setSelectedColumnValue] = useState('')

    const [SelectedRollingPeriod, setSelectedRollingPeriod] = useState('')
    const [SelectedRollingPeriodValue, setSelectedRollingPeriodValue] = useState('')

    const [SelectedTimeperiod, setSelectedTimeperiod] = useState('')
    const [SelectedTimeperiodValue, setSelectedTimeperiodValue] = useState('')

    const [Graph, setgraphData] = useState(null)
    const sortFeedsElements = (a,b) => new Date(b.date) - new Date(a.date)

    const handleChange = (dataset=SelectedDataset,column=SelectedColumnValue,rolling=SelectedRollingPeriodValue,timeperiod=SelectedTimeperiodValue,client_id=SelectedClientID,dataset_id=SelectedDatasetID,timeperiodName=SelectedTimeperiod,columnname=SelectedColumn) => {
        setgraphData(null)
        const dataset_label = `Change in ${columnname} (%), ${SelectedTimeperiod}`
        axios({
            method: 'POST',
            url: '/api/getNewTrendGraphData',
            data: {
                        dataset_label: dataset_label, 
                        dataset: dataset,
                        ColumnValue: column,
                        TimePeriodValue: timeperiod,
                        TimePeriodName: timeperiodName,
                        ColumnName: columnname,
                        client_id: client_id,
                        dataset_id: dataset_id,
                        rollingPeriod:rolling
                    }
        })
        .then(res => res.data)
        .then(res=> {
            setgraphData(res[0]?res[0]:[])
        })
    }
    

    useEffect(() =>{
        if (Datasets?.data?.length){            
            setDatasetOptions(Datasets?.data.map(item =>{return{'label':item.name,'value':item.value,'frequency':item.frequency}}))
            setSelectedDataset(Datasets?.data[0].name)
            setSelectedClientID(Datasets?.data[0].althub_client_id)
            setSelectedDatasetID(Datasets?.data[0].althub_dataset_id)
            setSelectedColumn(Datasets?.data[0].columns[0].name)
            setSelectedColumnValue(Datasets?.data[0].columns[0].value)
            setSelectedDatasetFrequency(Datasets?.data[0].frequency)
            setDatasetColumnOptions(Datasets?.data[0].columns.map(column =>{return{'label':column.name,'value':column.value,'description':column.description}}))
            let rollingPeriod = ''
            let timePeriod = ''
            let timePeriodName = ''
            if (Datasets?.data[0].frequency=="Daily"){
                setSelectedTimeperiod(Daily_Timeperiod_options[0].label)
                setSelectedTimeperiodValue(Daily_Timeperiod_options[0].value)
                setSelectedRollingPeriod(Daily_Rolling_options[4].label)
                setSelectedRollingPeriodValue(Daily_Rolling_options[4].value)
                rollingPeriod = Daily_Rolling_options[4].value
                timePeriod = Daily_Timeperiod_options[0].value
                timePeriodName = Daily_Timeperiod_options[0].label

            }
            else if (Datasets?.data[0].frequency=="Monthly"){
                setSelectedTimeperiod(Daily_Timeperiod_options[2].label)
                setSelectedTimeperiodValue(Daily_Timeperiod_options[2].value)
                setSelectedRollingPeriod(Monthly_Rolling_options[1].label)
                setSelectedRollingPeriodValue(Monthly_Rolling_options[1].value)
                rollingPeriod = Monthly_Rolling_options[1].value
                timePeriod = Daily_Timeperiod_options[2].value
                timePeriodName = Daily_Timeperiod_options[2].label
            }
            else{
                setSelectedTimeperiod(Daily_Timeperiod_options[3].label)
                setSelectedTimeperiodValue(Daily_Timeperiod_options[3].value)
                setSelectedRollingPeriod(Quarterly_Rolling_options[1].label)
                setSelectedRollingPeriodValue(Quarterly_Rolling_options[1].value)
                rollingPeriod = Quarterly_Rolling_options[1].value
                timePeriod = Daily_Timeperiod_options[3].value
                timePeriodName = Daily_Timeperiod_options[3].label
            }
        handleChange(Datasets?.data[0].name,Datasets?.data[0].columns[0].value, rollingPeriod, timePeriod, Datasets?.data[0].althub_client_id, Datasets?.data[0].althub_dataset_id,timePeriodName,Datasets?.data[0].columns[0].name)
        }
        return () => {}
    },[Datasets])
   
    // Old Code 
    // const feedDataAndDates = useMemo(() => (graphsData && userTriggerdAlerts && [...graphsData.map(obj => ({...obj, dataset: obj['dataset'], date: obj['created_at']})),
    // ...Object.entries(userTriggerdAlerts).map(([ticker, alerts])=> ({ticker, date: alerts[0]["triggered_at"], alerts}))]), [graphsData, userTriggerdAlerts])

    // Old Code 
    // const renderFeedByOrder = () => {
    //     const sortedElements = feedDataAndDates.sort(sortFeedsElements)
    //     const feed = sortedElements.map(el => {
    //         if (Object.keys(el).includes('ticker')){
    //             return (<div key={`${el.ticker}_${el.alerts[0].dataset}`}>
    //                 <FeedAlert ticker={el.ticker} alerts={el.alerts} key={el.ticker}/>
    //             </div>)
    //         }
    //         return (<NewsGraph graphData={el} key={el.dataset} Datasets={Datasets}/>)
    //     })
    //     return feed
    // }

    return (
        <section className={styles['feed-container']}>
                {/* <div className={styles['title']}>Feed</div> */}
                {/* <Typography variant='h3'>Feed</Typography> */}
                {/* <br/> */}
                <div style={{display:'flex',justifyContent:'center', width:'100%'}}>
                <Autocomplete
                    className="data-select"
                    size='small'
                    disablePortal
                    id="disable-clearable"
                    disableClearable
                    value={SelectedDataset}
                    style={{width:'100%', paddingRight: '10px'}}
                    options={DatasetOptions}
                    renderInput={(params) => <TextField {...params} label='Choose a Dataset' />}
                    onChange={(e,v)=>{
                        const tempData = Datasets?.data?.filter(dataset => dataset.value == v['value'])
                        setDatasetColumnOptions(tempData&&tempData[0].columns.map(column => {return{'label': column.name, 'value': column.value,'description':column.description}}))
                        setSelectedColumn(tempData[0].columns[0].name)
                        setSelectedColumnValue(tempData[0].columns[0].value)
                        setSelectedClientID(tempData[0].althub_client_id)
                        setSelectedDatasetID(tempData[0].althub_dataset_id)
                        let timePeriodValue = ''
                        let timePeriodName = ''
                        let rollingPeriodValue = ''
                        if (v['frequency']=="Daily"){
                            setSelectedTimeperiod(Daily_Timeperiod_options[0].label)
                            setSelectedTimeperiodValue(Daily_Timeperiod_options[0].value)
                            setSelectedRollingPeriod(Daily_Rolling_options[4].label)
                            setSelectedRollingPeriodValue(Daily_Rolling_options[4].value)
                            timePeriodValue = Daily_Timeperiod_options[0].value
                            timePeriodName = Daily_Timeperiod_options[0].label
                            rollingPeriodValue = Daily_Rolling_options[4].value
                        }
                        else if (v['frequency']=="Monthly"){
                            setSelectedTimeperiod(Daily_Timeperiod_options[2].label)
                            setSelectedTimeperiodValue(Daily_Timeperiod_options[2].value)
                            setSelectedRollingPeriod(Monthly_Rolling_options[1].label)
                            setSelectedRollingPeriodValue(Monthly_Rolling_options[1].value)
                            timePeriodValue = Daily_Timeperiod_options[2].value
                            timePeriodName = Daily_Timeperiod_options[2].label
                            rollingPeriodValue = Monthly_Rolling_options[1].value
                        }
                        else{
                            setSelectedTimeperiod(Daily_Timeperiod_options[3].label)
                            setSelectedTimeperiodValue(Daily_Timeperiod_options[3].value)
                            setSelectedRollingPeriod(Quarterly_Rolling_options[1].label)
                            setSelectedRollingPeriodValue(Quarterly_Rolling_options[1].value)
                            timePeriodValue = Daily_Timeperiod_options[3].value
                            timePeriodName = Daily_Timeperiod_options[3].label
                            rollingPeriodValue = Quarterly_Rolling_options[1].value
                        }
                        setSelectedDataset(v['value'])
                        setSelectedDatasetFrequency(v['frequency'])
                        handleChange(v['value'],tempData[0].columns[0].value,rollingPeriodValue,timePeriodValue,tempData[0].althub_client_id,tempData[0].althub_dataset_id,timePeriodName,tempData[0].columns[0].name)
                    }}
                />
                <Autocomplete
                    className="data-select"
                    size='small'
                    disablePortal
                    id="disable-clearable"
                    disableClearable
                    value={SelectedColumn}
                    style={{width:'100%',paddingRight: '10px'}}
                    options={DatasetColumnOptions}
                    renderInput={(params) => <TextField {...params} label='Choose a Dataset Column' />}
                    renderOption={(props, option) => (
                        <Tooltip key={option.label} title={option.description} placement="top" arrow>
                          <li {...props}>{option.label}</li>
                        </Tooltip>
                      )}
                    onChange={(e,v)=>{
                        setSelectedColumn(v['label'])
                        setSelectedColumnValue(v['value'])
                        handleChange(SelectedDataset,v['value'],SelectedRollingPeriodValue,SelectedTimeperiodValue,SelectedClientID,SelectedDatasetID,SelectedTimeperiod,v['label'])
                    }}
                />
                <Autocomplete
                    className="data-select"
                    size='small'
                    disablePortal
                    id="disable-clearable"
                    disableClearable
                    value={SelectedRollingPeriod}
                    style={{width:'100%',paddingRight: '10px'}}
                    options={SelectedDatasetFrequency =="Daily"?Daily_Rolling_options:SelectedDatasetFrequency =="Monthly"?Monthly_Rolling_options:Quarterly_Rolling_options}
                    renderInput={(params) => <TextField {...params} label='Choose a Rolling Period' />}
                    onChange={(e,v)=>{
                        // setSelectedDataset(v['value'])
                        setSelectedRollingPeriod(v['label'])
                        setSelectedRollingPeriodValue(v['value'])
                        handleChange(SelectedDataset,SelectedColumnValue,v['value'],SelectedTimeperiodValue,SelectedClientID,SelectedDatasetID,SelectedTimeperiod,SelectedColumn)

                    }}
                />
                <Autocomplete
                    className="data-select"
                    size='small'
                    disablePortal
                    id="disable-clearable"
                    disableClearable
                    value={SelectedTimeperiod}
                    style={{width:'100%', paddingRight: '10px'}}
                    getOptionDisabled={(option) => {
                        // Disable options based on the frequency value
                        if (SelectedDatasetFrequency == 'Weekly' && (option.value === 'daily')) {
                            return true;
                            }
                        if (SelectedDatasetFrequency == 'Monthly' && (option.value === 'daily' || option.value === 'weekly')) {
                            return true;
                        }
                        if (SelectedDatasetFrequency == 'Quarterly' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly')) {
                            return true;
                        }
                        if (SelectedDatasetFrequency == 'Biannually' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly' || option.value === 'quarterly')) {
                            return true;
                        }
                        if (SelectedDatasetFrequency == 'Yearly' && (option.value === 'daily'|| option.value === 'weekly'|| option.value === 'monthly' || option.value === 'quarterly' || option.value === 'biannually')) {
                            return true;
                        }
                        // Add more conditions based on the frequency value as needed
                        return false;
                        }}
                    options={Daily_Timeperiod_options}
                    renderInput={(params) => <TextField {...params} label='Choose a Time Period' />}
                    onChange={(e,v)=>{
                        setSelectedTimeperiod(v['label'])
                        setSelectedTimeperiodValue(v['value'])
                        handleChange(SelectedDataset,SelectedColumnValue,SelectedRollingPeriodValue,v['value'],SelectedClientID,SelectedDatasetID,v['label'],SelectedColumn)
                    }}
                />
                </div>
                {Graph?<NewsGraph graphData={Graph} key={SelectedDataset} Datasets={Datasets}/>:<Skeleton width="100%" height={500} variant="rect"/>}
                {/* Old Code {graphsData && userTriggerdAlerts && renderFeedByOrder()} */}
        </section>
    )
}
